<script>
  import { fade } from "svelte/transition";
  import Spinner  from './Spinner.svelte';
  export let img;
  $: src = "https://storage.googleapis.com/littleadeline/" + img.name;

  let el;
  $: style = "background-image:url('" + src + "');height:" + width + "px";
  let width = 300;
  let isOpen = false;
  $: document.body.classList[isOpen ? 'add' : 'remove']('noscroll');
  let isLoading = true;
  function openModal() {
    isOpen = true;
  }
  function closeModal() {
    isOpen = false;
  }
  function handleLoad(){
      isLoading = false;
  }
</script>

<main>
  <div class="card">
    <div class="card-image">
      <figure class="image c-thumbnail" on:click={openModal}>
        {#if isLoading}
            <Spinner/>
        {/if}
        <img {src} alt="Placeholder image" on:load={handleLoad}/>
      </figure>
    </div>
  </div>
  {#if isOpen}
    <div transition:fade={{ duration: 250 }} class="modal is-active">
      <div class="modal-background" on:click={closeModal} />
      <div class="c-img-content modal-content">
        <p class="image ">
          <img {src} alt="" />
        </p>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        on:click={closeModal}
      />
    </div>
  {/if}
</main>

<style>
  .c-img-content {
    width: auto;
  }
  .c-img-content img {
    max-height: calc(100vh - 40px);
  }
  .c-bg-img {
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0.25rem;
  }
  .c-thumbnail {
    background-color: #f1f1f1;
    transition: transform 0.1s;
  }
  .c-thumbnail:hover {
    cursor: pointer;
    transform: scale(1.025) rotate(0.01deg);
    width: 100%;
  }
</style>
